export const DEFAULT_CASHIER_THEME_PRESET_ID = "crypto";

export const cashierThemePresets = [
  {
    id: "crypto",
    label: "Crypto",
    description: "Web3 inspired style",
    preview: {
      canvasBackground: "linear-gradient(180deg, #CED4E3 0%, #AEB7CE 100%)",
      canvasImageUrl: "/presets/crypto/bg-crypto.png",
      canvasImageOpacity: 0.35,
      appBackground: "#E0E3EC",
      headerBackground:
        "linear-gradient(130deg, #5E53AB 0%, #8F7BEA 100%), url('/presets/crypto/bg-crypto.png')",
      headerTextColor: "#FFFFFF",
      bannerImageUrl: "/presets/crypto/bg-crypto.png",
      bodyBackground: "#E6E6EA",
      optionBackground: "#E6E6EA",
      optionBorderColor: "#FFFFFF",
      optionActiveBorderColor: "#8F7BEA",
      buttonBackground: "#8F7BEA",
      buttonTextColor: "#FFFFFF",
      textColor: "#1D2640",
      subTextColor: "#5E6685",
      cardBackground: "linear-gradient(135deg, #D7D6F2 0%, #B9B4E9 100%)",
      cardTextColor: "#1D2640",
      showAnnouncement: false,
      announcementText: "Pay with 50+ cryptocurrencies",
      announcementBackground: "#B6A8FF",
      announcementTextColor: "#211E4B",
      logoImageUrl: "/presets/crypto/cyberpay-logo-light.svg",
      logoText: "CS",
      badgeColor: "#97A4D8",
      badgeBackground: "#D7DDF6",
      dividerColor: "rgba(143, 123, 234, 0.25)",
      panelShadow: "0 16px 35px rgba(43, 33, 103, 0.18)",
    },
  },
  {
    id: "slick",
    label: "Slick",
    description: "Sleek professional dark slate style",
    preview: {
      canvasBackground: "linear-gradient(140deg, #5F768E 0%, #3A4B63 100%)",
      canvasImageUrl: null,
      canvasImageOpacity: 0,
      appBackground: "linear-gradient(145deg, #465D76 0%, #2C3D53 100%)",
      headerBackground: "linear-gradient(145deg, #4A5F79 0%, #2F425A 100%)",
      headerTextColor: "#F2F6FF",
      bannerImageUrl: null,
      bodyBackground: "linear-gradient(145deg, #31445D 0%, #25354A 100%)",
      optionBackground: "rgba(15, 25, 38, 0.38)",
      optionBorderColor: "#D7E0EC",
      optionActiveBorderColor: "#9DB2C9",
      buttonBackground: "linear-gradient(90deg, #5F7893 0%, #6B849E 100%)",
      buttonTextColor: "#FFFFFF",
      textColor: "#F2F6FF",
      subTextColor: "#C2CDDC",
      cardBackground: "linear-gradient(128deg, #2F4159 0%, #405470 100%)",
      cardTextColor: "#F2F6FF",
      cardBorderColor: "rgba(215, 224, 236, 0.45)",
      showAnnouncement: false,
      announcementText: "Stay ahead of what is next",
      announcementBackground: "#5F7893",
      announcementTextColor: "#F2F6FF",
      logoImageUrl: null,
      logoText: "SL",
      badgeColor: "#F2F6FF",
      badgeBackground: "rgba(143, 164, 190, 0.5)",
      dividerColor: "rgba(215, 224, 236, 0.35)",
      panelShadow: "0 16px 35px rgba(16, 25, 39, 0.35)",
    },
  },
  {
    id: "lotto",
    label: "Lotto",
    description: "Lotto Mambo warm style",
    preview: {
      canvasBackground: "#FFF5EB",
      canvasImageUrl: null,
      canvasImageOpacity: 0,
      appBackground: "#FFF5EB",
      headerBackground: "linear-gradient(90deg, #FFCB2B 0%, #FF8C13 100%)",
      headerTextColor: "#1F2937",
      bannerImageUrl: null,
      bodyBackground:
        "linear-gradient(137.82deg, rgb(245, 245, 245) 37.835%, rgb(255, 207, 156) 88.86%)",
      optionBackground: "#FFFFFF",
      optionBorderColor: "#D99F8F",
      optionActiveBorderColor: "#3C0150",
      buttonBackground: "linear-gradient(90deg, #FFCB2B 0%, #FF8C13 100%)",
      buttonTextColor: "#252525",
      textColor: "#333333",
      subTextColor: "#7A3A22",
      cardBackground: "linear-gradient(90deg, #FFCB2B 0%, #FF8C13 100%)",
      cardTextColor: "#111111",
      cardBorderColor: "#FF8C13",
      showAnnouncement: false,
      announcementText: "Get 15% Off on first order!",
      announcementBackground: "#E18A00",
      announcementTextColor: "#232323",
      logoImageUrl: "/presets/crypto/cyberpay-logo.svg",
      logoText: "LM",
      badgeColor: "#8B2A0E",
      badgeBackground: "#C56D4D",
      dividerColor: "rgba(117, 33, 10, 0.25)",
      panelShadow: "0 16px 35px rgba(157, 75, 16, 0.22)",
    },
  },
  {
    id: "lotto-2",
    label: "Lotto 2",
    description: "Dark lotto variant",
    preview: {
      canvasBackground: "linear-gradient(140deg, #43034B 0%, #260C33 100%)",
      canvasImageUrl: null,
      canvasImageOpacity: 0,
      appBackground: "linear-gradient(140deg, #43034B 0%, #260C33 100%)",
      headerBackground: "linear-gradient(180deg, #B037B7 0%, #6A0E70 100%)",
      headerTextColor: "#FFFFFF",
      bannerImageUrl: null,
      bodyBackground: "linear-gradient(140deg, #43034B 0%, #260C33 100%)",
      optionBackground: "#200328",
      optionBorderColor: "#7A258D",
      optionActiveBorderColor: "#FDC85E",
      buttonBackground: "linear-gradient(90deg, #FFCB2B 0%, #FF8C13 100%)",
      buttonTextColor: "#252525",
      textColor: "#FFFFFF",
      subTextColor: "#D9BBF4",
      cardBackground: "linear-gradient(90deg, #FFCB2B 0%, #FF8C13 100%)",
      cardTextColor: "#111111",
      cardBorderColor: "#FF8C13",
      showAnnouncement: false,
      announcementText: "Get 15% Off on first order!",
      announcementBackground: "#F1A100",
      announcementTextColor: "#252525",
      logoImageUrl: "/presets/crypto/cyberpay-logo.svg",
      logoText: "LM",
      badgeColor: "#E4C2FF",
      badgeBackground: "#9A4BAE",
      dividerColor: "rgba(253, 200, 94, 0.3)",
      panelShadow: "0 16px 35px rgba(47, 6, 60, 0.4)",
    },
  },
  {
    id: "gaming",
    label: "Gaming",
    description: "Gaming and entertainment",
    preview: {
      canvasBackground: "linear-gradient(140deg, #522433 0%, #3B1B1B 100%)",
      canvasImageUrl: null,
      canvasImageOpacity: 0,
      appBackground: "linear-gradient(140deg, #522433 0%, #3B1B1B 100%)",
      headerBackground: "linear-gradient(140deg, #6E2D3B 0%, #3B1B1B 100%)",
      headerTextColor: "#FFFFFF",
      bannerImageUrl: "/presets/gaming/hero-gaming.png",
      bodyBackground: "#F7F7F7",
      optionBackground: "#FFFFFF",
      optionBorderColor: "#EAEAEA",
      optionActiveBorderColor: "#B6393D",
      buttonBackground: "#602527",
      buttonTextColor: "#FFFFFF",
      textColor: "#222222",
      subTextColor: "#6B7280",
      cardBackground: "linear-gradient(90deg, #FFCB2B 0%, #FF8C13 100%)",
      cardTextColor: "#1F2937",
      cardBorderColor: "#FF8C13",
      showAnnouncement: false,
      announcementText: "Jackpot weekend is live!",
      announcementBackground: "#FFCB2B",
      announcementTextColor: "#1F2937",
      logoImageUrl: null,
      logoText: "CS",
      badgeColor: "#8E8E8E",
      badgeBackground: "#DFDFDF",
      dividerColor: "rgba(0, 0, 0, 0.08)",
      panelShadow: "0 16px 35px rgba(40, 12, 18, 0.35)",
    },
  },
  {
    id: "lime",
    label: "Lime",
    description: "Clean paper surfaces with lime accents",
    preview: {
      canvasBackground: "#F1F1EE",
      canvasImageUrl: null,
      canvasImageOpacity: 0,
      appBackground: "#FFFFFF",
      headerBackground: "#F5F3EE",
      headerTextColor: "#0B0B0C",
      bannerImageUrl: null,
      bodyBackground: "#FFFFFF",
      optionBackground: "#FFFFFF",
      optionBorderColor: "#E4E4DE",
      optionActiveBorderColor: "#0B0B0C",
      buttonBackground: "#C6F03A",
      buttonTextColor: "#0B0B0C",
      textColor: "#0B0B0C",
      subTextColor: "#5C5C57",
      cardBackground: "#F5F3EE",
      cardTextColor: "#0B0B0C",
      cardBorderColor: "#D6D6CF",
      showAnnouncement: false,
      badgeColor: "#0B0B0C",
      badgeBackground: "#C6F03A",
      dividerColor: "#E4E4DE",
      panelShadow: "0 14px 34px -20px rgba(11, 11, 12, 0.14)",
    },
  },
];
